import { apiRequest } from '../../api-client';

export interface DeleteEnterpriseUsersParams {
  token: string;
  enterpriseId: string;
  keycloakIds: string[];
}

export interface DeleteEnterpriseUsersResult {
  deleted: number;
  skipped: number;
  failures: { keycloakId: string; reason: string }[];
}

/**
 * Bulk remove users from an enterprise.
 * DELETE /api/internal/admin/enterprises/:enterprise_id/members/bulk
 */
export function deleteEnterpriseUsers({
  token,
  enterpriseId,
  keycloakIds
}: DeleteEnterpriseUsersParams): Promise<DeleteEnterpriseUsersResult> {
  return apiRequest<DeleteEnterpriseUsersResult>({
    method: 'DELETE',
    endpoint: `/api/internal/admin/enterprises/${enterpriseId}/members/bulk`,
    token,
    body: { keycloakIds }
  });
}
